import React, { useCallback, useState, useEffect, createElement as _createElement } from 'react';
import { connect } from 'react-redux';
import { Toolbar } from '@leverege/ui-plugin';
import { Plugins, Match } from '@leverege/plugin';
import { UserSettings } from '@leverege/ui-redux';
import { SearchRendererFactory } from "./renderer/Factory.js";
import GroupedTextFilterModel from "./filter/GroupedTextFilterModel.js";
import { FilterSourceModel } from "../../../filters/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
function SearchBar(props) {
  const client = 'molten.group.SearchBar';
  const {
    variant,
    filterName,
    onFilterChange,
    relationship,
    relationship: {
      path
    },
    objectType,
    filterModel,
    headerVariant,
    areaVariant,
    filter = FilterSourceModel.create(),
    renderAs = 'popup',
    toolbarVariant = 'actionBar',
    suggestionsVariant = 'suggestions',
    focusOnMount = false,
    actionBarMatchContext = {
      use: 'actionBar',
      client,
      objectType,
      path
    },
    suggestionsEnabled = true,
    suggestionsMatchContext = {
      use: 'suggestions',
      client,
      objectType,
      path
    },
    onFocus,
    defaultModel = GroupedTextFilterModel
  } = props;
  const Model = filterModel?.type && Plugins.getFactory('Model').get(filterModel) || defaultModel;

  // try and use metadata value since its cleaner, but fall back on filter value
  const [search, setSearch] = useState(FilterSourceModel.getMetadata(filter)?.value || FilterSourceModel.getFilter(filter)?.value);
  useEffect(() => {
    setSearch(FilterSourceModel.getMetadata(filter)?.value || FilterSourceModel.getFilter(filter)?.value);
  }, [FilterSourceModel.getMetadata(filter)?.value, FilterSourceModel.getFilter(filter)?.value]);
  const suggesters = suggestionsEnabled ? Plugins.get('SearchSuggester', suggester => Match.isMatch(suggestionsMatchContext, suggester.matches)) : [];
  const onSearchChange = ({
    value
  }) => {
    if (typeof value !== 'string') {
      return;
    }
    const model = Model.toImagineFilter(filterModel, objectType);
    const nValue = Model.toImagineValue ? Model.toImagineValue(value, filterModel, objectType) : value;
    let newFilter = FilterSourceModel.setFilter(filter, nValue ? {
      ...model,
      value: nValue
    } : null);
    newFilter = FilterSourceModel.setMetadata(newFilter, {
      value
    });
    onFilterChange({
      data: filterName,
      value: newFilter
    });
    if (search !== value) {
      setSearch(value);
      suggesters.forEach(suggester => suggester?.onSearchChange?.({
        search: value,
        relationship,
        suggestionsMatchContext
      }));
    }
  };
  const refreshSearch = () => onSearchChange({
    value: search
  });
  const clearSearch = useCallback(() => onSearchChange({
    value: ''
  }), [props]);
  const value = FilterSourceModel.getFilter(filter)?.value;
  const context = {
    client,
    clientProps: {
      ...props,
      renderAs,
      suggestionsVariant,
      searchModel: Model
    },
    clearSearch,
    onSearchChange,
    value,
    search
  };
  const suggCxt = {
    client,
    clearSearch,
    onSearchChange,
    value,
    search,
    renderAs,
    suggestionsVariant,
    ...props
  };
  const post = /*#__PURE__*/_jsx(Toolbar, {
    variant: toolbarVariant,
    prefer: "icon",
    matchContext: actionBarMatchContext,
    context: context
  });
  const listenForEnter = evt => {
    if (evt.key === 'Enter') {
      onSearchChange({
        value: search
      });
    }
  };
  return SearchRendererFactory.create(renderAs, {
    variant,
    headerVariant,
    focusOnMount,
    search,
    post,
    refreshSearch,
    areaVariant,
    suggesters: suggesters.map(({
      suggestions: Suggestions,
      id
    }) => /*#__PURE__*/_createElement(Suggestions, {
      ...suggCxt,
      key: id
    })),
    listenForEnter,
    onSearchChange,
    setSearch,
    suggestionsVariant,
    onFocus
  });
}
export default connect((state, props) => ({
  filterModel: UserSettings.get(state, props.settingsPath, {
    returnPromise: false
  })
}))(SearchBar);